export const getFrameElement = () => {
  try {
    return window.frameElement;
  } catch {
    // Edge throws error an error when accessing frameElement inside
    // a cross origin iframe while spec stays it should return null
    return null;
  }
};
